import { render, staticRenderFns } from "./AccountSettingUOM.vue?vue&type=template&id=61209184&"
import script from "./AccountSettingUOM.vue?vue&type=script&lang=js&"
export * from "./AccountSettingUOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61209184')) {
      api.createRecord('61209184', component.options)
    } else {
      api.reload('61209184', component.options)
    }
    module.hot.accept("./AccountSettingUOM.vue?vue&type=template&id=61209184&", function () {
      api.rerender('61209184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingUOM.vue"
export default component.exports